import { Toolbar, InputBase, IconButton, Badge, Button, Box } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import CartIcon from "components/Icons/CartIcon";
import NotificationIcon from "components/Icons/NotificationIcon";
import { ReactComponent as LogoutIcon } from "assets/icons/logout.svg";
import { ReactComponent as Nine_dots } from "assets/icons/9_dots/Nine_dots.svg";
import { ReactComponent as Menubar } from "assets/icons/9_dots/menu_bar.svg";
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import SyncModal from "components/ui/RemoveModal/RemoveModal";
import { useSettingContext } from "context/SettingContext";
import RestricateCategoryHeader from "./RestricateCategoryHeader";
import RightSideBarModal from "components/ui/RightSideBarModal/RightSideBarModal";
import { useGlobalContext } from "context/GlobalContext";
import { ReactComponent as SearchIconPlaceHolder } from "assets/icons/searchicon.svg";
import Tooltip from "components/ui/Tooltip";
import { revertAllactionTypeData } from "features/Setting/Synchronize/apis/RevertAllActionType";
import { handleRevertAllFunc } from "features/Setting/Synchronize/utils/handleRevertAll";
import { useQueryClient } from "@tanstack/react-query";
import QuickCreate from "components/Icons/QuickCreate";
import QuickDrawer from "components/ui/QuickDrawer/QuickDrawer";
import list from "../../db/drawerOptions.json";
import OrdersNotificationModal from "features/Setting/order/components/OrdersNotificationModal";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
  marginLeft: 0,
  width: "100%",
  boxShadow: "inset 0px 4px 20px 0px #00000040",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "black",
  height: "40px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 1),
    transition: theme.transitions.create("width"),

    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));

const SettingHeader = () => {
  const [logoutModal, setLogoutModal] = React.useState(false);
  const [tempSearch, setTempSearch] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [orderModalOpen, setOrderModalOpen] = useState(false);

  const { search, setSearch, searchBar, syncModal, setSyncModal, ReverAlltModal, setRevertAllModal, restrictBtn, syncButton } = useSettingContext();
  const { rightSideBar, setRightSideBar, setDynamicFilterCount, searchPlaceHolder, setNotificationCount, notificationCount } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname;

  // console.log("path====>>>",path, "location====>>>", location);
  // console.log("path====>>>", path.includes("/melting-requests"));

  
  
  const navigate = useNavigate();
  const quaryClient = useQueryClient();

  const isRestricted = location?.state?.isRestricted || false;
  const innerChnages = location?.state && location?.state?.innerChnages ? location?.state?.innerChnages : false;

  const setCookie = (name, value, days = 7) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
  };

  function handlelogout() {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("userData");
    localStorage.removeItem("userData");
    navigate("/login");
  }

  const handleSearch = () => {
    setSearch(tempSearch);
    setDynamicFilterCount(false);
  };

  useEffect(() => {
    setTempSearch(search);
  }, [search]);

  const modalBtnInfo = React.useMemo(
    () => [
      {
        btnName: "log out",
        bgColor: "#E77B7B",
        click: handlelogout,
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => setLogoutModal(false),
      },
    ],
    []
  );

  const SyncBtnInfo = React.useMemo(
    () => [
      {
        btnName: "Discard",
        bgColor: "#E77B7B",
        click: () => setSyncModal(false),
      },
      {
        btnName: "Confirm",
        bgColor: "#50C878",
        click: () => "",
      },
    ],
    []
  );

  const RevertBtnInfo = React.useMemo(
    () => [
      {
        btnName: "Discard",
        bgColor: "#E77B7B",
        click: () => setRevertAllModal(false),
      },
      {
        btnName: "Revert All",
        bgColor: "#50C878",
        click: () => {
          handleRevertAllFunc(path?.split("/")[3], navigate, location, setRevertAllModal);
          quaryClient.invalidateQueries("getSyncList");
          quaryClient.removeQueries("getSyncList");
        },
      },
    ],
    [path]
  );

  useEffect(() => {
    if (tempSearch === "") {
      setSearch("");
    }
  }, [tempSearch]);

  const renderHeader = () => {
    switch (true) {
      case path.includes("/missing-images") || path.includes("/synchronize"):
        return (
          <div position="fixed" elevation={0} sx={{ backgroundColor: "#000" }}>
            <Toolbar sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "12px" }}>
              <Search
                sx={{
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: "10px",
                  paddingRight: "4px",
                }}
              >
                {/* Search Icon inside Input */}
                <SearchIconPlaceHolder sx={{ color: "gray", marginRight: "8px" }} />

                <StyledInputBase
                  placeholder={"Search By Category or Design Number"}
                  onChange={(e) => setTempSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch();
                    }
                  }}
                  value={tempSearch}
                  inputProps={{ "aria-label": "search" }}
                  sx={{ height: "40px", borderRadius: "5px" }}
                />

                <IconButton
                  disableRipple
                  disableFocusRipple
                  sx={{
                    color: "black",
                    height: "34px",
                    width: "69px",
                    borderRadius: "5px",
                    padding: "10px",
                    background: "#000",
                    fontFamily: "poppins",
                    color: "#fff",
                    fontWeight: "500",
                    fontSize: "12px",
                  }}
                  onClick={search === "" ? handleSearch : () => setSearch("")}
                >
                  {search === "" ? "Search" : "Clear"}
                </IconButton>
              </Search>

              {!path.includes("/orders") && (
                <IconButton size="large" edge="end" color="success" disableRipple disableFocusRipple>
                  <Badge color="success">
                    <CartIcon color="white" />
                  </Badge>
                </IconButton>
              )}
              <IconButton size="large" color="success" disableRipple disableFocusRipple>
                <Badge color="success">
                  <NotificationIcon color="white" />
                </Badge>
              </IconButton>
              {/* <IconButton size="large" edge="end" color="success" disableRipple disableFocusRipple onClick={() => setLogoutModal(true)}>
                <LogoutIcon />
              </IconButton> */}
              <Box>
                <Tooltip title="Menu" marginTop="-5px">
                  <IconButton size="large" edge="start" color="success" onClick={() => setRightSideBar(true)} disableRipple disableFocusRipple>
                    {rightSideBar ? <Menubar /> : <Nine_dots />}
                  </IconButton>
                </Tooltip>
              </Box>
            </Toolbar>
          </div>
        );
      case path.includes("/restricted-designs") ||
        path.includes("/orders") ||
        path.includes("/product-usp-and-gallery") ||
        path.includes("/my-binnys-access") ||
        path.includes("/stock-tray") ||
        path.includes("/event-type") ||
        path.includes("archives/Catalog") ||
        path.includes("archives/Sets") ||
        path.includes("/archives/Orders") || 
        path === "/Setting/service-request" ||
        path.includes("/melting-requests") ||
        path.includes("/Setting/limits/limitClient") ||
        path.includes("/Setting/limits/limitUser") ||
        path.includes("/users"):
        return (
          <div position="fixed" elevation={0} sx={{ backgroundColor: "#000" }}>
            <Toolbar sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "12px", marginRight: "8px" }}>
              {!isRestricted ? (
              <>
               {/* {restrictBtn && <Search>
                    <StyledInputBase placeholder="Search" inputProps={{ "aria-label": "search" }} sx={{ height: "40px", borderRadius: "5px" }} onChange={(e) => setSearch(e.target.value)} />
                  </Search>} */}
                {searchBar && (
                  <Search
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      paddingRight: "4px",
                    }}
                  >
                     {/* Search Icon inside Input */}
                    <SearchIconPlaceHolder sx={{ color: "gray", marginRight: "8px" }} />
                    <StyledInputBase
                        placeholder={searchPlaceHolder || "Search By Category or Design Number"}
                      onChange={(e) => setTempSearch(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSearch();
                        }
                      }}
                      value={tempSearch}
                      inputProps={{ "aria-label": "search" }}
                      sx={{ height: "40px", borderRadius: "5px" }}
                    />
                    <IconButton
                      disableRipple
                      disableFocusRipple
                      sx={{
                        color: "black",
                        height: "34px",
                        width: "69px",
                        borderRadius: "5px",
                        padding: "10px",
                        background: "#000",
                        fontFamily: "poppins",
                        color: "#fff",
                        fontWeight: "500",
                        fontSize: "12px",
                      }}
                      onClick={search === "" ? handleSearch : () => setSearch("")}
                    >
                      {search === "" ? "Search" : "Clear"}
                    </IconButton>
                  </Search>
                )}
                {path.includes("/restricted-designs") && (
                  <IconButton size="large" edge="end" color="success" disableRipple disableFocusRipple>
                    <Badge color="success">
                      <CartIcon color="white" />
                    </Badge>
                  </IconButton>
                )}
                {path.includes("/product-usp-and-gallery") && (
                  <IconButton size="large" edge="end" color="success" disableRipple disableFocusRipple>
                    <Badge color="success">
                      <CartIcon color="white" />
                    </Badge>
                  </IconButton>
                )}

                {!innerChnages && (
                  <Tooltip title="Quick Create" marginTop="-5px">
                    <IconButton size="large" edge="end" disableRipple disableFocusRipple onClick={() => setDrawerOpen(true)}>
                      <QuickCreate />
                    </IconButton>
                  </Tooltip>
                )}
                <QuickDrawer open={drawerOpen} handleClose={() => setDrawerOpen(false)} data={list} />

                <Tooltip title="Notifications" marginTop="-5px">
                  {/* {notificationCount > 0 && <div>notificationCount</div>} */}
                  <IconButton
                    size="large"
                    color="success"
                    disableRipple
                    disableFocusRipple
                    onClick={() => {
                      setNotificationCount(0); // clear the count
                      setCookie("notificationCount", 0);
                      setOrderModalOpen(true); // open the modal
                    }}
                  >
                    <Badge badgeContent={notificationCount} color="success">
                      <NotificationIcon color={notificationCount === 0 ? "white" : "#50C878"} />
                    </Badge>
                  </IconButton>
                </Tooltip>
                <OrdersNotificationModal open={orderModalOpen} handleClose={() => setOrderModalOpen(false)} />
                  {/* <IconButton size="large" edge="end" color="success" disableRipple disableFocusRipple onClick={() => setLogoutModal(true)}>
                    <LogoutIcon />
                  </IconButton> */}
                <Box>
                  <Tooltip title="Menu" marginTop="-5px">
                    <IconButton size="large" edge="start" color="success" onClick={() => setRightSideBar(true)} disableRipple disableFocusRipple>
                      {rightSideBar ? <Menubar /> : <Nine_dots />}
                    </IconButton>
                  </Tooltip>
                </Box>
              </>
            ) : (
              <>
                {/* Show RestricateCategoryHeader for restricted designs AND melting requests in remove mode */}
                {(path.includes("/restricted-designs") || 
                  (path.includes("/melting-requests") && location.state?.isRestricted)) && (
                  <RestricateCategoryHeader />
                )}
              </>
            )}
          </Toolbar>
        </div>
      );

      case "test":
        return <h1>Test</h1>;

      default:
        return (
          <div position="fixed" elevation={0} sx={{ backgroundColor: "#000" }}>
            <Toolbar></Toolbar>
          </div>
        );
    }
  };

  return (
    <>
      {renderHeader()}
      <RemoveModal open={logoutModal} setOpen={setLogoutModal} btnInfo={modalBtnInfo} heading="Are you sure you want to log out?" />
      <SyncModal open={syncModal} setOpen={setSyncModal} btnInfo={SyncBtnInfo} heading="Are you sure you want to sync all?" />
      <SyncModal open={ReverAlltModal} setOpen={setRevertAllModal} btnInfo={RevertBtnInfo} heading="Are you sure you want to revert all?" />
      <RightSideBarModal open={rightSideBar} setOpen={setRightSideBar} modalBtnInfo={modalBtnInfo} logoutModal={logoutModal} setLogoutModal={setLogoutModal} />
    </>
  );
};

export default SettingHeader;
